/* eslint-disable */
export function capitalizeTitle(title) {
  const exceptions = [
    'the',
    'of',
    'in',
    'and',
    'a',
    'an',
    'but',
    'or',
    'on',
    'at',
    'to',
    'with',
    'by',
    'for',
  ];

  if (!title) return '';
  return title
    .split(' ') // Split the title into individual words
    .map((word, index, arr) => {
      // Capitalize the first and last word, or if not in the exceptions list
      if (!word) return '';
      if (
        index === 0 ||
        index === arr.length - 1 ||
        !exceptions.includes(word)
      ) {
        let capitalWord = word.charAt(0).toUpperCase();
        if (word.length > 1) {
          capitalWord = capitalWord + word.slice(1);
        }
        return capitalWord;
      }
      return word;
    })
    .join(' ');
}

export function getWholeWords(text, start, end) {
  // Move the start index to the beginning of the word if in the middle
  while (start > 0 && /\S/.test(text[start - 1])) {
    start--;
  }
  // Move the end index to the end of the word if in the middle
  while (end < text.length && /\S/.test(text[end])) {
    end++;
  }
  return text.substring(start, end).trim();
}

export function getFocusedSentences(text, start, end) {
  const sentenceEndings = /[.!?]/;

  const before = text.slice(0, start);
  const sentenceStart = before.search(/[^.!?]*$/);

  const after = text.slice(end);
  const nextPunctuation = after.search(sentenceEndings);

  const sentenceEnd =
    nextPunctuation === -1 ? text.length : end + nextPunctuation + 1;

  return text.slice(sentenceStart, sentenceEnd).trim();
}

export function getFocusedParagraphs(text, start, end) {
  const before = text.slice(0, start);
  const after = text.slice(end);

  const paragraphStart = before.lastIndexOf('\n') + 1 || 0;
  const paragraphEnd =
    after.indexOf('\n') === -1 ? text.length : end + after.indexOf('\n');

  return text.slice(paragraphStart, paragraphEnd).trim();
}
